import { render } from "./WhatsAppMessagesPerAgencyCustomerView.vue?vue&type=template&id=f5ef01d4&scoped=true"
import script from "./WhatsAppMessagesPerAgencyCustomerView.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessagesPerAgencyCustomerView.vue?vue&type=script&lang=js"

import "./WhatsAppMessagesPerAgencyCustomerView.vue?vue&type=style&index=0&id=f5ef01d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ef01d4"]])

export default __exports__